import BackgroundSelector from '@/components/ui/BackgroundSelector'
// import CopyTextField from '@/components/ui/CopyTextField'
import TextEditor from '@/components/ui/TextEditor.vue'
import LocationPicker from '@/components/pickers/LocationPicker.vue'
import TableField from '@/components/ui/TableField.vue'

export default {
  computed: {
    fields() {
      let currency = this.currency
      if (this.product && this.product.currency) { currency = this.product.currency }
      let hasAutoCodes = this.product && this.product.auto_codes && this.product.auto_codes.length > 0
      let priceHint = 'This is the default price for this appointment and will be set when the appointment is created. You can change the price later, and it will be adjusted automatically if you add ICD10 codes'
      if (hasAutoCodes) {
        priceHint = 'Pricing for this product is managed by the ICD-10 codes that are configured to be automatically added (see automation section below)'
      }
      let fields = [
        {
          attrs: {label: 'Background'},
          id: 'background_picture',
          component: BackgroundSelector,
          containerAttrs: { xs12: true, sm12: true },
          extra: true
        },
        { text: 'General settings', id: 'heading-general', component: 'subheader', containerAttrs: { xs12: true } },
        {
          id: 'title',
          attrs: {
            label: 'Name',
            persistentHint: true,
            hint: 'e.g.: Initial consultation, follow-up consultation, 45 minute therapy session'
          },
          containerAttrs: { xs12: true }
        },
        {
          id: 'duration',
          attrs: {
            label: 'Duration',
            suffix: 'mins',
            persistentHint: true,
            hint: 'How long is this appointment type (in minutes)',
            type: 'number'
          },
          containerAttrs: { xs12: true, sm6: true},
        },
        {
          attrs: {
            label: 'Price',
            prefix: currency,
            type: 'number',
            disabled: hasAutoCodes,
            persistentHint: true,
            hint: priceHint
          },
          id: 'price',
          containerAttrs: { xs12: true, sm6: true},
        },
        // { attrs: {label: 'Private', id: 'private' }},
        {
          id: 'order',
          attrs: {
            label: 'Order',
            persistentHint: true,
            hint: 'The order in which this should appear on your website and booking forms',
            type: 'number'
          },
          containerAttrs: { xs12: true, sm6: true},
        },
        {
          attrs: {
            label: 'Booking notice',
            items: [
              { text: 'Same day', value: 0 },
              { text: 'Next day', value: 1440 },
              { text: '2 day', value: 2880 }
            ]
          },
          id: 'booking_notice_in_minutes',
          component: 'vselect',
          hint: 'How much notice do you require for bookings placed online (only relevant if you allow online bookings)',
          containerAttrs: { xs12: true, sm6: true}
        },
        {
          id: 'locations',
          attrs: {
            spaceId: this.spaceId,
            dense: false,
            returnObject: false,
            inline: true,
            multiple: true,
            label: 'At which locations is this appointment type available?'
          },
          component: LocationPicker
        },
        { text: 'Advanced settings', id: 'heading-advanced', component: 'subheader', extra: true, containerAttrs: { xs12: true } },
        // { attrs: {label: 'Currency', id: 'currency', default: 'ZAR' }},
        {
          id: 'description',
          type: 'text',
          extra: true,
          containerAttrs: { xs12: true, sm12: true, md6: true },
          attrs: {
            label: 'Description',
            initialAttrs: {
              filled: true,
              hint: 'The description will show on your booking page. You can also use it in your notificiations: <code>{appointment.product.description}</code>'
            }
          },
          component: TextEditor,
          displayInTable: false
        },
        {
          id: 'notes',
          type: 'text',
          extra: true,
          component: TextEditor,
          attrs: {
            label: 'Notes',
            initialAttrs: {
              filled: true,
              hint: 'Use notes to provide extra information about this appintment. e.g.: What to wear, what to expect, how to prepare. Ideal for adding extra information to your notifications <code>{appointment.product.notes}</code>'
            }
          },
          containerAttrs: { xs12: true, sm12: true, md6: true },
          displayInTable: false
        },
        {
          attrs: {
            label: 'Online',
            persistentHint: true,
            hint: 'Check this if this is a virtual appointment that occurs online (e.g.: with Zoom)'
          },
          extra: true,
          id: 'is_online',
          type: 'boolean',
          containerAttrs: { xs12: true, sm6: true},
          component: 'vcheckbox'
        },
        {
          attrs: {
            label: 'Flexible location',
            persistentHint: true,
            hint: 'Check this if the location for this appontment can vary. For example: a house call or a meeting in a coffee shop'
          },
          extra: true,
          containerAttrs: { xs12: true, sm6: true},
          id: 'comes_to_you',
          type: 'boolean',
          component: 'vcheckbox'
        },
        {
          attrs: {
            label: 'Private',
            persistentHint: true,
            hint: 'Private appointments do not show up on your website or booking page, but you can send a direct booking link to a customer'
          },
          extra: true,
          id: 'private',
          type: 'boolean',
          component: 'vcheckbox'
        },
        { text: 'Automation', icon: 'mdi-flash', iconColor: 'amber', id: 'heading-automation', component: 'subheader', extra: true, containerAttrs: { xs12: true } },
        {
          id: 'auto_codes',
          extra: true,
          containerAttrs: { xs12: true },
          attrs: {
            title: 'Automatically add codes',
            hint: 'AppointmentGuru can automatically add codes to an appointment based on the appointment type. Add any codes you would like to be automatically added to appointments of this type here',
            headers: [
              {
                text: 'ICD-10',
                value: 'icd10',
                sortable: false
              },
              {
                text: 'Tariff codes',
                value: 'process',
                sortable: false
              },
              {
                text: 'Price',
                value: 'price',
                sortable: false,
                attrs: {
                  prepend: 'ZAR',
                  type: 'number'
                }
              }
            ]
          },
          component: TableField,
          displayInTable: false
        },
        {
          attrs: {
            label: 'Discount',
            prefix: currency,
            type: 'number',
            persistentHint: true,
            hint: 'Automatically add a discount to this type of appointment'
          },
          id: 'discount',
          containerAttrs: { xs12: true, sm6: true},
        },
        { text: 'Danger Zone', icon: 'mdi-alert', iconColor: 'amber', id: 'heading-danger', component: 'subheader', containerAttrs: { xs12: true }, extra: true },
        {
          id: 'archived',
          attrs: {
            label: 'Archive',
            persistentHint: true,
            color: 'error',
            hint: 'Archived appointment types are not visible in the user interface',
            cardAttrs: {
              color: 'grey lighten-4'
            }
          },
          type: 'boolean',
          component: 'vcheckbox',
          extra: true
        }
      ]
      if (this.settings && this.settings.showExtraFields === true) {
        return fields
      } else {
        return fields.filter((field) => {
          if (!field.extra) { return field }
        })
      }
    }
  }
}